import liteAppManageApi from '@api/xiu_yan/liteAppManageApi'
import { getLiteAppType } from '@components/LocalMerchant/LiteApp/util'
import { LITE_APP_NOT_OPEN, LITE_APP_PUBLIC } from '@constant'
import { isSiDaProperty } from '@merchant-backend/util'
import { cantUse } from '@util'
import { action, observable } from 'mobx'
import { hashHistory } from 'react-router'

class Store {
  @observable visible = false
  @observable codeUrl = ''
  @observable notOpen = false

  @action
  openModal = () => {
    if (isSiDaProperty()) {
      cantUse()
      return
    }
    this.checkLiteApp()
    this.visible = true
  }

  @action
  close = () => {
    this.visible = false
  }

  checkLiteApp = async () => {
    const type = getLiteAppType()
    // 未开通
    if (type == LITE_APP_NOT_OPEN) {
      this.codeUrl = '//qnm.hunliji.com/o_1co9sn0fu1pagugikmg1j2r59.png'
      this.notOpen = true
      return
    }

    let resp
    const params = { page: 'merchant' }

    if (type == LITE_APP_PUBLIC) {
      // 公共版
      resp = await liteAppManageApi.WXACodeUrlShare(params)
    } else {
      // 专享版
      resp = await liteAppManageApi.WXACodeUrl(params)
    }
    const {
      success,
      data: { merchant_wxacode }
    } = resp
    if (!merchant_wxacode) {
      hashHistory.push('/localMerchant/liteApp')
    }

    if (success) {
      this.codeUrl = merchant_wxacode
    }
  }
}

export default Store
